import { Asset, MimeType } from '@facephi/inphinite-common';
import { IconWrapper } from '@facephi/ui-react';
import { ImageLoad } from './ImageLoad';

type IProps = {
  asset: Asset;
};

export const AssetFile = ({ asset }: IProps) => {
  const ImageComponent = () => <ImageLoad asset={asset} />;
  const PdfComponent = () => <IconWrapper color="grey" iconName="FilePdf" />;
  const VideoComponent = () => (
    <IconWrapper color="grey" iconName="VideoCamera" />
  );
  const AudioComponent = () => (
    <IconWrapper color="grey" iconName="Microphone" />
  );

  const typeDocument = {
    [MimeType.jpg]: ImageComponent,
    [MimeType.png]: ImageComponent,
    [MimeType.pdf]: PdfComponent,
    [MimeType.jpeg]: ImageComponent,
    [MimeType.mp4]: VideoComponent,
    [MimeType.wav]: AudioComponent,
  };

  const ComponentResource = typeDocument[asset.contentType];

  return typeDocument[asset.contentType] ? <ComponentResource /> : null;
};
